import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const DELETE_TEMPLATE = gql`
  mutation DeleteTemplate($domain: String!, $ids: [Int!]!) {
    report {
      deleteTemplate(domain: $domain, ids: $ids) {
        code
        message
        success
      }
    }
  }
`

export interface DeleteTemplateResponse {
  report: {
    deleteTemplate: Def_MutationResponse
  }
}